// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"143b4f36","172":"c581c40e","451":"817736a2","487":"81e914e9","567":"d26d20e7","788":"816e68de"}[chunkId] + ".chunk.js";
};